import { Component, OnInit, ChangeDetectorRef, Output, EventEmitter, ViewChild, signal, computed } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {} from 'rxjs/operators';
import { firstValueFrom } from 'rxjs';
import { SearchCandidateService } from 'src/app/core/services/searchCandService-service';
import { UntypedFormControl } from '@angular/forms';
import { SchedulerCandidate, ActivityModel } from 'src/app/shared/models/schedulerAssociate';
import { AssociateService } from '../../services/associate.service';
import { IroleProcessActivity } from 'src/app/shared/models/activity';
import {
  CheckstatusChangeObj,
  HrPanelInterviewObj,
  CheckInterviewSchDataObj,
  CorrespondenceDataObj,
  CheckSuitabilityDataObj,
  DataIds,
  isApplicantsActivityAvailable,
} from 'src/app/shared/models/activity-dashboard-model';
import { ActivityService } from 'src/app/core/services/activity.service';
import { MatMenuTrigger } from '@angular/material/menu';
import { PersonaService } from 'src/app/core/services/persona.service';
import { MatDialog } from '@angular/material/dialog';
import { JobDesComponent } from 'src/app/modules/schedulerpersona/components/job-des/job-des.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { RequisitionShareDialogComponent } from 'src/app/modules/recruiterpersona/components/requisition-share-dialog/requisition-share-dialog.component';
import { SchedulerAdminService } from '../../services/admin.service';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';

@Component({
  selector: 'app-search-candidate-detail',
  templateUrl: './search-candidate-detail.component.html',
  styleUrls: ['./search-candidate-detail.component.scss'],
  standalone: false,
})
export class SearchCandidateDetailComponent implements OnInit {
  private readonly hiddenInterviewActionActivityIds = new Set([200304, 500305, 500307, 600305, 200201, 500202, 500203]);
  selectedCandidateId;
  candidateEmails = [];
  dataSource = [];
  displayedColumns = [
    'requisitionName',
    'applicationId',
    'companyHiringTypeName',
    'applicationDate',
    'activityName',
    'processName',
    'applicationStatus',
    'subStatus',
    'sourceName',
    'sourceExpiryDate',
    'isReOffered',
  ];
  loginUserName;
  applicationIds = [];
  isSearch = true;
  resumeData;
  fileId;
  resData;
  blob: Blob;
  candAppIds;
  recruiter = true;
  candidateBasicDetails;
  companyHiringType1 = localStorage.getItem('fresherCompHiringTypeId');
  compHiringId = Number(this.companyHiringType1);
  selectedAssignmentTab = new UntypedFormControl(0);
  selectedAssignmentIndex = this.selectedAssignmentTab.value;
  groupedActivities: any;
  activityModel: ActivityModel[];
  processActivityList: IroleProcessActivity[] = [];
  pendingAutoTrigger: string = '';
  autoTriggerActivity: string = '';
  roleCode = '';
  editactivityflag = false;
  activityState: boolean = false;
  interviewFlag: boolean = false;
  candidateApplicationIds: number[] = [];
  candidatesList: SchedulerCandidate[] = [];
  selectedCandidate: SchedulerCandidate[] = [];
  processStage = 'Pre Screening';
  selectedRequisitionId;
  innerWidth: any;
  popupData: any;
  @Output() refreshpostingcandiates: EventEmitter<any> = new EventEmitter();
  @ViewChild('trigger') trigger: MatMenuTrigger;
  interviewDetails: any;
  appId: any;
  activityMode: any;
  selectedInterviewIds: Set<any> = new Set();
  // activity part starts

  onPreScreen: boolean = false;
  onScreen: boolean = false;
  onInterview: boolean = false;
  correspondenceDataObj: CorrespondenceDataObj;
  checkHrPanelInterviewObj: HrPanelInterviewObj;
  checkSuitabilityDataObj: CheckSuitabilityDataObj;
  checkInterviewSchDataObj: CheckInterviewSchDataObj;
  checkStatusChangeObj: CheckstatusChangeObj;
  onHrPanelInterview: boolean = false;
  onSuitability: boolean = false;
  onCorrespondence: boolean = false;

  onInterviewSchedule: boolean = false;

  onStatusChangeSchedule: boolean = false;

  //edit variables
  onSuitabilityEdit: boolean = false;
  onStatusChangeScheduleEdit: boolean = false;
  onHrPanelInterviewEdit: boolean = false;
  onCorrespondenceEdit: boolean = false;
  onInterviewScheduleEdit: boolean = false;

  coupledOnStatusChangeScheduleEdit: boolean = false;
  coupledOnSuitabilityEdit: boolean = false;
  coupledOnCorrespondenceEdit: boolean = false;
  coupledhrpanelInterviewEdit: boolean = false;
  coupledOnInterviewScheduleEdit: boolean = false;

  // coupled variables
  ifCoupled: boolean = false;
  coupledCheckSuitabilityDataObj: CheckSuitabilityDataObj;
  coupledCheckInterviewSchDataObj: CheckInterviewSchDataObj;
  coupledCheckStatusChangeObj: CheckstatusChangeObj;
  couplledCorrespondenceDataObj: CorrespondenceDataObj;
  coupledcheckHrPanelInterviewObj: HrPanelInterviewObj;
  coupledOnInterviewSchedule: boolean = false;
  coupledhrpanelInterview: boolean = false;
  coupledEditHrPanelInterview: boolean = false;
  coupledOnStatusChangeSchedule: boolean = false;
  coupledOnSuitability: boolean = false;
  coupledOnCorrespondence: boolean = false;

  coupled2CheckSuitabilityDataObj: CheckSuitabilityDataObj;
  coupled2CheckInterviewSchDataObj: CheckInterviewSchDataObj;
  coupled2CheckStatusChangeObj: CheckstatusChangeObj;
  couplled2CorrespondenceDataObj: CorrespondenceDataObj;
  coupled2checkHrPanelInterviewObj: HrPanelInterviewObj;
  coupled2OnCorrespondence: boolean = false;
  coupled2OnInterviewSchedule: boolean = false;
  coupled2hrpanelInterview: boolean = false;
  coupled2OnStatusChangeSchedule: boolean = false;
  coupled2OnSuitability: boolean = false;

  // @Input() application;
  editcheckSuitabilityDataObj: CheckSuitabilityDataObj;
  coupledEditCheckSuitabilityDataObj1: CheckSuitabilityDataObj;
  coupledEditCheckSuitabilityDataObj2: CheckSuitabilityDataObj;
  // = <CheckSuitabilityDataObj> {};
  editcheckCorrespondenceDataObj: CorrespondenceDataObj;
  coupledEditCheckCorrespondenceDataObj1: CorrespondenceDataObj;
  coupledEditCheckCorrespondenceDataObj2: CorrespondenceDataObj;

  // =<CorrespondenceDataObj>{};
  editcheckInterviewDataObj: CheckInterviewSchDataObj;
  coupledEditCheckInterviewDataObj1: CheckInterviewSchDataObj;
  coupledEditCheckInterviewDataObj2: CheckInterviewSchDataObj;

  // = <CheckInterviewSchDataObj>{};
  editcheckStatusChangeDataObj: CheckstatusChangeObj;
  coupledEditCheckStatusChangeDataObj1: CheckstatusChangeObj;
  coupledEditCheckStatusChangeDataObj2: CheckstatusChangeObj;

  editcheckHrPanelInterviewObj: HrPanelInterviewObj;
  coupledEditCheckHrPanelInterviewObj1: HrPanelInterviewObj;
  coupledEditCheckHrPanelInterviewObj2: HrPanelInterviewObj;
  enabled: boolean;
  processStageDisable: boolean = false;
  candObject = {};
  objA = {};
  formioFlag: any;

  notReachableCountScheduling: number;
  notReachableCountInterview: number;
  notAvailableCountScheduling: number;
  notAvailableCountInterview: number;

  notReachableDateScheduling: Date;
  notReachableDateInterview: Date;
  notAvailableDateScheduling: Date;
  notAvailableDateInterview: Date;
  // noShowCount:number;

  noOfTimesActsExcted: number;
  amcatId = signal<any>(null);
  showShlAssessment = computed(() => this.compHiringId === 4 && !isNaN(Number(this.amcatId())) && Number(this.amcatId()) !== 0);
  minDateAllowed: Date;
  showBackButton = signal(false);
  hideIWPSharing = signal((window as any).env.hideShareButton);
  private dataLoadStatus = {
    processActivities: false,
    candidateList: false,
    applicationIds: false,
  };

  updateifcoupled(_$event) {
    this.trigger.closeMenu();
    this.ifCoupled = true;
  }
  updateSuitability($event) {
    this.trigger.closeMenu();
    //this.onSuitability = $event;
    const obj: CheckSuitabilityDataObj = $event;
    this.onSuitability = obj.isVisible;
    this.checkSuitabilityDataObj = obj;
    console.log('HERE !!!!!');
    console.log(obj);
  }

  updateInterviewSchedule($event) {
    this.trigger.closeMenu();
    // this.onInterview = $event;
    console.log($event);

    const obj: CheckInterviewSchDataObj = $event;
    this.onInterviewSchedule = obj.isVisisble;
    this.checkInterviewSchDataObj = obj;
    this.interviewFlag = true;
    console.log('Hi');

    console.log(this.checkInterviewSchDataObj);
  }

  updateCorrespondence($event) {
    this.trigger.closeMenu();
    //this.onCorrespondence = $event;
    const obj: CorrespondenceDataObj = $event;
    this.onCorrespondence = obj.isVisible;
    this.correspondenceDataObj = obj;
    console.log('corrospendence obj', this.correspondenceDataObj);
  }

  updateStatusChange($event) {
    this.trigger.closeMenu();
    const obj: CheckstatusChangeObj = $event;
    this.onStatusChangeSchedule = obj.isVisisble;
    this.checkStatusChangeObj = obj;
    console.log('HiStatusChange');
    console.log(this.checkStatusChangeObj);
    this.noOfTimesActsExcted = undefined;
    this.setNoOfTimesActs(obj);
    // Auto-scroll to activity section with retry mechanism
    this.changeDetector.detectChanges();
    setTimeout(() => this.scrollToElement('statusChangeActivity'));
  }

  updateHrPanelChange($event) {
    this.trigger.closeMenu();
    const obj: HrPanelInterviewObj = $event;
    this.onHrPanelInterview = obj.isVisible;
    this.checkHrPanelInterviewObj = obj;
    console.log('inhrinterview obj ');
  }

  updateROA($event) {
    this.updateSuitability($event);
  }

  get showInterviewActionButtons(): boolean {
    const lastActivityId = Number(this.activityService.lastActivityPerformed?.activityid);
    const hasTechnicalInterviews = Array.isArray(this.interviewDetails) && this.interviewDetails.some((detail: any) => detail.interviewName?.includes('[Technical]'));
    const isRecruiter = this.roleCode === 'Recruiter';
    const isInterviewHiringType = this.applicationIds?.[this.selectedAssignmentIndex]?.companyHiringTypeId == 1;
    const isAllowedByActivity = !lastActivityId || !this.hiddenInterviewActionActivityIds.has(lastActivityId);

    return this.dataLoadStatus.processActivities && hasTechnicalInterviews && isRecruiter && isInterviewHiringType && isAllowedByActivity;
  }

  updatePreScreenProcess($event) {
    this.onPreScreen = $event;
  }

  updateScreenProcess($event) {
    this.onScreen = $event;
  }

  updateInterviewProcess($event) {
    this.onInterview = $event;
  }

  //coupled update methods

  updateSuitabilityCoupled($event) {
    //this.onSuitability = $event;
    const obj: CheckSuitabilityDataObj = $event;
    this.coupledOnSuitability = obj.isVisible;
    this.coupledCheckSuitabilityDataObj = obj;
    console.log(this.coupledOnSuitability);
    console.log('HERE !!!!!');
    console.log(obj);
  }

  updateInterviewScheduleCoupled($event) {
    // this.onInterview = $event;
    console.log($event);

    const obj: CheckInterviewSchDataObj = $event;
    this.coupledOnInterviewSchedule = obj.isVisisble;
    this.coupledCheckInterviewSchDataObj = obj;
    console.log('Hi');
    this.interviewFlag = true;
    console.log(this.coupledCheckInterviewSchDataObj);
  }

  updateCorrespondenceCoupled($event) {
    console.log('inside update event');
    //this.onCorrespondence = $event;
    const obj: CorrespondenceDataObj = $event;
    this.coupledOnCorrespondence = obj.isVisible;
    this.couplledCorrespondenceDataObj = obj;
    console.log('corrospendence obj', this.couplledCorrespondenceDataObj);
  }

  updateStatusChangeCoupled($event) {
    const obj: CheckstatusChangeObj = $event;
    this.coupledOnStatusChangeSchedule = obj.isVisisble;
    this.coupledCheckStatusChangeObj = obj;
    console.log('HiStatusChange');

    console.log(this.coupledCheckStatusChangeObj);
  }

  updateHrPanelChangeCoupled($event) {
    this.trigger.closeMenu();
    const obj: HrPanelInterviewObj = $event;
    this.coupledhrpanelInterview = obj.isVisible;
    this.coupledcheckHrPanelInterviewObj = obj;
    console.log('inhrinterview obj ');
  }

  // coupled 2 methods

  updateSuitabilityCoupled2($event) {
    //this.onSuitability = $event;
    const obj: CheckSuitabilityDataObj = $event;
    this.coupled2OnSuitability = obj.isVisible;
    this.coupled2CheckSuitabilityDataObj = obj;
    console.log(this.coupled2OnSuitability);
    console.log('HERE !!!!!');
    console.log(obj);
  }

  updateInterviewScheduleCoupled2($event) {
    // this.onInterview = $event;
    console.log($event);

    const obj: CheckInterviewSchDataObj = $event;
    this.coupled2OnInterviewSchedule = obj.isVisisble;
    this.coupled2CheckInterviewSchDataObj = obj;
    console.log('Hi');
    this.interviewFlag = true;

    console.log(this.coupled2CheckInterviewSchDataObj);
  }

  updateCorrespondenceCoupled2($event) {
    console.log('inside update event');
    //this.onCorrespondence = $event;
    const obj: CorrespondenceDataObj = $event;
    this.coupled2OnCorrespondence = obj.isVisible;
    this.couplled2CorrespondenceDataObj = obj;
    console.log('corrospendence obj', this.couplled2CorrespondenceDataObj);
  }

  updateStatusChangeCoupled2($event) {
    const obj: CheckstatusChangeObj = $event;
    this.coupled2OnStatusChangeSchedule = obj.isVisisble;
    this.coupled2CheckStatusChangeObj = obj;
    console.log('Hi,StatusChange2');

    console.log(this.coupled2CheckStatusChangeObj);
  }
  updateHrPanelChangeCoupled2($event) {
    this.trigger.closeMenu();
    const obj: HrPanelInterviewObj = $event;
    this.coupled2hrpanelInterview = obj.isVisible;
    this.coupled2checkHrPanelInterviewObj = obj;
    console.log('inhrinterview obj ');
  }

  // activity part ends
  constructor(
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private _searchCandServ: SearchCandidateService,
    private activityService: ActivityService,
    private associateService: AssociateService,
    private changeDetector: ChangeDetectorRef,
    private _personaService: PersonaService, private router: Router,
    private ngxLoader: NgxUiLoaderService,
    private fileDownloadService: FileDownloadService,
  ) { }
    openDialog(): void {
      const dialogRef = this.dialog.open(JobDesComponent, {
        width: '649.22px',
        height: '500px',
         data: { jobData: this.popupData}
      });
      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
        this.selectedRequisitionId=null;
      });

  }

  toggleInterviewSelection(interviewId: any): void {
    if (this.selectedInterviewIds.has(interviewId)) {
      this.selectedInterviewIds.delete(interviewId);
    } else {
      this.selectedInterviewIds.add(interviewId);
    }
  }

  clearSelectedInterviews(): void {
    this.selectedInterviewIds.clear();
  }

  shareSelectedInterviews(): void {
    const selectedIds = Array.from(this.selectedInterviewIds);
    const selectedInterviews = (this.interviewDetails || []).filter((d: any) => selectedIds.includes(d.iwpInterviewId));

    const dialogRef = this.dialog.open(RequisitionShareDialogComponent, {
      width: '450px',
      maxHeight: '90vh',
      data: {
        title: 'Share Interview Feedback',
        selectedInterviews: selectedIds,
        showVerificationSnapshot: true,
        
      }
    });

    dialogRef.afterClosed().subscribe((shareData: any) => {
      if (!shareData) {
        return;
      }
        const hiringManagers = Array.isArray(shareData.hiringManagers) ? shareData.hiringManagers : [];
        const payload = {
            candidateId: this.selectedCandidateId,
            interviewId: selectedIds,
            applicationId: this.appId,
            fromDate: shareData.fromDate,
            toDate: shareData.toDate,
            hiringManagerEmail: hiringManagers.map((hm) => hm?.email).filter(Boolean),
            hiringManagerName: hiringManagers.map((hm) => hm?.empName).filter(Boolean),
            hiringManagerId: hiringManagers.map((hm) => hm?.empId).filter((id) => id != null),
            hiringType: this.applicationIds[this.selectedAssignmentIndex].companyHiringTypeId,
            isSnapshot: shareData.includeVerificationSnapshot ? 'Y' : 'N',
          };
         
         this.ngxLoader.start();
         this._personaService.shareContent(payload, 'interview').subscribe({
          next: (res) => {
            this.selectedInterviewIds.clear();
            this.activityService.openSnackBar({ msg: 'Notification mail sent successfully to HM', isSuccess: true }, 'success-snack');
            this.ngxLoader.stop();
          },
          error: (err) => {
            this.activityService.openSnackBar({ msg: 'Failed to send notification mail to HM', isSuccess: false }, 'danger-snack');
            this.ngxLoader.stop();
          }
         });
      });
  }

  openInterviewDetails(candId, interviewId) {
    console.log(interviewId);

    let interviewObj;
    this.interviewDetails.forEach((element) => {
      if (element.iwpInterviewId == interviewId) {
        this.formioFlag = element.formioFlag;
        interviewObj = {
          appId: this.appId,
          interviewId: interviewId,
        };
      }
    });

    if (this.formioFlag == 'N' || this.formioFlag == null) {
      this.router.navigate(['scheduler/search/interview-results-standard/', candId], {
        state: { interviewObj: interviewObj },
      });
    } else {
      this.router.navigate(['scheduler/search/interview-results/', candId], { state: { interviewObj: interviewObj } });
    }
  }

  ngOnInit() {
    // Subscribe to route parameter changes to handle navigation to same route
    this.route.paramMap.subscribe((params) => {
      // Check if navigated from recruiter's action pending tab
      const userTabLocation = localStorage.getItem('userTabLocation');
      const stored = localStorage.getItem('autoTriggerState');
      let autoTriggerAppId: number | null = null;
      if (stored) {
        const parsedState = JSON.parse(stored);
        this.autoTriggerActivity = parsedState.activity;
        autoTriggerAppId = parsedState.applicationId;
        // Clear the localStorage after reading to prevent re-triggering
        localStorage.removeItem('autoTriggerState');

        // Show back button only when redirected to activity from Action Pending screen
        if (userTabLocation) {
          const tabSelectionObj = JSON.parse(userTabLocation);
          if (tabSelectionObj.recruiterTab === 'Action Pending') {
            this.showBackButton.set(true);
          }
        }
      }

      this.selectedCandidateId = Number(params.get('id'));
      console.log(this.selectedCandidateId);
      this.candObject['candidateId'] = this.selectedCandidateId;
      this.objA['candidateId'] = this.selectedCandidateId;
      this._searchCandServ.getApplicationIDs(this.selectedCandidateId).subscribe((appIds) => {
        this.applicationIds = appIds;
        this.dataLoadStatus.applicationIds = true;

        // Find the correct assignment index based on autoTriggerAppId
        let initialIndex = 0;
        if (autoTriggerAppId) {
          const foundIndex = this.applicationIds.findIndex((obj) => obj.applicationId === autoTriggerAppId);
          if (foundIndex !== -1) {
            initialIndex = foundIndex;
            this.selectedAssignmentTab.setValue(initialIndex);
            this.selectedAssignmentIndex = initialIndex;
          }
        }

        this.processStageDisable =
          this.applicationIds[initialIndex].companyHiringTypeId ==
          parseInt(localStorage.getItem('fresherCompHiringTypeId'))
            ? false
            : true;
        this.dataSource = [];
        this.dataSource.push(this.applicationIds[initialIndex]);
        console.log(this.applicationIds);
        this.appId = this.applicationIds[initialIndex].applicationId;
        this.candObject['applicationId'] = this.appId;
        this.activityService.setObject(this.candObject);
        this.objA['applicationId'] = this.appId;
        this.activityService.setObj(this.objA);
        this.interviewDetails = this.applicationIds[0].interviewDetails;
        this.amcatId.set(this.dataSource[0].amcatId);
        console.log(this.amcatId(), '-----AMCAT ID');

        const appId = this.applicationIds[0].applicationId;
        console.log('datasource---', this.dataSource[0].employeenumber, this.dataSource[0].sourceName);
        if (this.dataSource[0].sourceName == 'Employee Referral') {
          if (this.dataSource[0].subStatus != '') {
            this._searchCandServ.updateSubstatus(this.dataSource[0].subStatus);
            this.displayedColumns = [
              'requisitionName',
              'applicationId',
              'companyHiringTypeName',
              'applicationDate',
              'activityName',
              'processName',
              'applicationStatus',
              'subStatus',
              'sourceName',
              'sourceExpiryDate',
              'employeeNumber',
              'isReOffered',
            ];
          } else {
            this.displayedColumns = [
              'requisitionName',
              'applicationId',
              'companyHiringTypeName',
              'applicationDate',
              'activityName',
              'processName',
              'applicationStatus',
              'sourceName',
              'sourceExpiryDate',
              'employeeNumber',
              'isReOffered',
            ];
          }
        } else {
          if (this.dataSource[0].subStatus != '') {
            this.displayedColumns = [
              'requisitionName',
              'applicationId',
              'companyHiringTypeName',
              'applicationDate',
              'activityName',
              'processName',
              'applicationStatus',
              'subStatus',
              'sourceName',
              'sourceExpiryDate',
              'isReOffered',
            ];
          } else {
            this.displayedColumns = [
              'requisitionName',
              'applicationId',
              'companyHiringTypeName',
              'applicationDate',
              'activityName',
              'processName',
              'applicationStatus',
              'sourceName',
              'sourceExpiryDate',
              'isReOffered',
            ];
          }
        }

        if (this.dataSource[0].processName == 'Hiring' && this.dataSource[0].activityName == 'Joined') {
          this.displayedColumns.push('candiadteEmployeeId');
        }
        this.getCandidateBasicDetails(appId, this.selectedCandidateId);
        this.setViewProfile();
        // if (this.roleCode == '') {
        //   this.roleCode = 'Recruiter';
        // }
        this.candidateApplicationIds = [];
        this.candidateApplicationIds.push(this.applicationIds[0].applicationId);
        this.getFooterActivities();
        // this.getActivitiesOnCandidate(this.applicationIds[0].applicationId, this.selectedCandidateId)
        const appsIds = [];
        this.applicationIds.forEach((element) => {
          console.log('element', element);

          appsIds.push(element.applicationId);
        });
        this.getCandidateListByIds(appsIds);
      });
      this._personaService.getLoggedUserDetails().subscribe(
        (res) => {
          if (res) {
            // console.log('data ---->', data, typeof data);
            this.loginUserName = res.empName;
          }
        },
        (_err) => {
          // console.log('error',err.status);
        },
      );
    }); // Close paramMap subscription
  }
  async synciwp(detail) {
    this.ngxLoader.start();
    try {
      const companyHiringTypeId = this.applicationIds[this.selectedAssignmentIndex].companyHiringTypeId;
      const res = await firstValueFrom(this._searchCandServ.syncApi(detail.applicationId, companyHiringTypeId));
      const appsData = await firstValueFrom(this._searchCandServ.getApplicationIDs(this.selectedCandidateId));
      if (appsData?.[this.selectedAssignmentIndex]) {
        this.interviewDetails = appsData[this.selectedAssignmentIndex].interviewDetails;
      }
      this.ngxLoader.stop();
      const data = {
        msg: res.message,
        isSuccess: true,
      };
      if (res.status == 'Success') {
        data.isSuccess = true;
        this.activityService.openSnackBar(data, 'success-snack');
      } else {
        data.isSuccess = false;
        this.activityService.openSnackBar(data, 'danger-snack');
      }
    } catch (err) {
      console.log('error--', err);
      this.ngxLoader.stop();
      this.activityService.openSnackBar({ msg: 'An error occurred', isSuccess: false }, 'danger-snack');
    }
  }

  getCandidateBasicDetails(applicationId, candidateId) {
    this._searchCandServ.getCandidateBasicDetails(applicationId, candidateId).subscribe((res) => {
      this.candidateBasicDetails = res;
      console.log('souvik', this.candidateBasicDetails);
    });
  }
  onAssignmentChange(tabChangeEvent) {
    if (this.selectedAssignmentIndex !== this.selectedAssignmentTab.value) {
      this.onSuitability = false;
      this.onCorrespondence = false;
      this.onInterviewSchedule = false;
      this.onStatusChangeSchedule = false;
      this.onHrPanelInterview = false;
      this.ifCoupled = false;

      this.selectedAssignmentIndex = this.selectedAssignmentTab.value;
      console.log(this.selectedAssignmentIndex);
      console.log(tabChangeEvent);
    }
    this.selectedCandidate[0].applicationId = this.applicationIds[this.selectedAssignmentIndex].applicationId;
    this.candObject['applicationId'] = this.appId;
    this.activityService.setObject(this.candObject);
    this.objA['applicationId'] = this.appId;
    this.activityService.setObj(this.objA);
    this.processStageDisable =
      this.applicationIds[this.selectedAssignmentIndex].companyHiringTypeId ==
      parseInt(localStorage.getItem('fresherCompHiringTypeId'))
        ? false
        : true;
    this.appId = this.applicationIds[this.selectedAssignmentIndex].applicationId;
    this.amcatId.set(this.applicationIds[this.selectedAssignmentIndex]?.amcatId);
    this.setViewProfile();
    this.interviewDetails = [];
    this.interviewDetails = this.applicationIds[this.selectedAssignmentIndex].interviewDetails;
    this.dataSource = [];
    this.dataSource.push(this.applicationIds[this.selectedAssignmentIndex]);
    if (this.dataSource[0].sourceName == 'Employee Referral') {
      if (this.dataSource[0].subStatus != '') {
        this.displayedColumns = [
          'requisitionName',
          'applicationId',
          'companyHiringTypeName',
          'applicationDate',
          'activityName',
          'processName',
          'applicationStatus',
          'subStatus',
          'sourceName',
          'sourceExpiryDate',
          'employeeNumber',
          'isReOffered',
        ];
      } else {
        this.displayedColumns = [
          'requisitionName',
          'applicationId',
          'companyHiringTypeName',
          'applicationDate',
          'activityName',
          'processName',
          'applicationStatus',
          'sourceName',
          'sourceExpiryDate',
          'employeeNumber',
          'isReOffered',
        ];
      }
    } else {
      if (this.dataSource[0].subStatus != '') {
        this.displayedColumns = [
          'requisitionName',
          'applicationId',
          'companyHiringTypeName',
          'applicationDate',
          'activityName',
          'processName',
          'applicationStatus',
          'subStatus',
          'sourceName',
          'sourceExpiryDate',
          'isReOffered',
        ];
      } else {
        this.displayedColumns = [
          'requisitionName',
          'applicationId',
          'companyHiringTypeName',
          'applicationDate',
          'activityName',
          'processName',
          'applicationStatus',
          'sourceName',
          'sourceExpiryDate',
          'isReOffered',
        ];
      }
    }
    if (this.dataSource[0].processName == 'Hiring' && this.dataSource[0].activityName == 'Joined') {
      this.displayedColumns.push('candiadteEmployeeId');
    }
    this.candidateApplicationIds = [];
    this.candidateApplicationIds.push(this.applicationIds[this.selectedAssignmentIndex].applicationId);
    this.getActivitiesOnCandidate(
      this.applicationIds[this.selectedAssignmentIndex].applicationId,
      this.selectedCandidateId,
      'assignChange',
    );
  }

  setViewProfile() {
    this.candAppIds = {
      candidateId: this.selectedCandidateId,
      applicationId: this.appId,
      screenName: 'Scheduler',
    };
    this.roleCode = localStorage.getItem('role');
    if (this.roleCode == 'Scheduler') {
      this.candAppIds.screenName = 'Scheduler';
    } else if (this.roleCode == 'Recruiter') {
      this.candAppIds.screenName = 'Recruiter';
    } else if (this.roleCode == 'Offer DEO') {
      this.candAppIds.screenName = 'Offer_ViewProfile';
    } else {
      this.candAppIds.screenName = 'Scheduler';
    }
  }

  getActivitiesOnCandidate(applicationId, candidateId, parent?) {
    this.groupedActivities = null;
    this.associateService.getActivitiesOnCandidate(applicationId, candidateId).subscribe((res) => {
      this.activityModel = res.activityModel;
      this.activityService.lastActivityPerformed = this.activityModel.slice(-1)[0];
      this.activityService.allActivityPerformed = this.activityModel;
      this.activityService.activityAPICheck = parent;
      const candidateActivities: any = [];
      console.log(this.processActivityList);

      if (this.activityModel) {
        this.activityModel.forEach((ca) => {
          // this.processActivityList.forEach(process => {
          //   process.activityprocess.map(activityprocess => {
          // if (Number(ca.activityid) === Number(activityprocess.activityId)) {
          const returnobj: any = {
            editflag: this.getEditFlag(ca),
            readflag: this.getReadFlag(ca),
            activityId: ca.activityid,
            processId: ca.processid,
            processName: ca.processName,
            activityType: ca.activityType,
            activityDescription: ca.activityDescription,
            statusId: ca.statusid,
            createdOn: ca.createdOn,
            createdBy: ca.createdBy,
            modifiedOn: ca.modifiedOn,
            modifiedBy: ca.modifiedBy,
            modifiedByName: ca.modifiedByName,
            unavailableDate: ca.unavailableDate,
          };
          localStorage.setItem('processName_', returnobj.processName);
          // console.log('return object', returnobj);
          candidateActivities.push(returnobj);
          // }
          // });
          // })
        });
      }
      if (this.activityModel) {
        this.groupedActivities = candidateActivities.reduce((prev, activty) => {
          // prev[activty.modifiedOn.substring(0, activty.modifiedOn.indexOf("T"))] = prev[activty.modifiedOn.substring(0, activty.modifiedOn.indexOf("T"))] || [];
          // prev[activty.modifiedOn.substring(0, activty.modifiedOn.indexOf("T"))].push(activty);
          prev[activty.processId] = prev[activty.processId] || [];
          prev[activty.processId].push(activty);
          return prev;
        }, Object.create(null));

        console.log('group activity---', this.groupedActivities);

        this.getActsCount();
        const ordered = {};

        Object.keys(this.groupedActivities)
          .sort()
          .forEach((key) => {
            console.log('keys', key);
            ordered[key] = this.groupedActivities[key];
            console.log(ordered);
          });
        console.log('sort grouped--', ordered);
      }
    });
  }
  getEditFlag(act) {
    const proces = this.processActivityList.filter((item) => {
      return act.processid == item.processId;
    })[0];

    let filterdObj;
    if (proces) {
      filterdObj = proces.activityprocess.filter((item) => {
        return act.activityid == item.activityId;
      })[0];
    }
    if (filterdObj) {
      return filterdObj['edit'];
    } else {
      return false;
    }
  }
  getReadFlag(actR) {
    const procesR = this.processActivityList.filter((itemR) => {
      return actR.processid == itemR.processId;
    })[0];

    let filterdObjR;
    if (procesR) {
      filterdObjR = procesR.activityprocess.filter((item) => {
        return actR.activityid == item.activityId;
      })[0];
    }
    if (filterdObjR) {
      return filterdObjR['read'];
    } else {
      return false;
    }
  }
  getFooterActivities() {
    //console.log('get footer activities called');

    this.associateService.getProcessActivities(this.roleCode).subscribe((res) => {
      //console.log(res);
      //console.log('inside get process activities');

      const data = res.processModel;
      //console.log('processModel', data);
      this.processActivityList = data;
      this.dataLoadStatus.processActivities = true;
      if (this.autoTriggerActivity) {
        this.pendingAutoTrigger = this.autoTriggerActivity;
        this.autoTriggerActivity = ''; // reset so it only fires once
      }
      this.tryAutoTriggerMenu();
      // Hardcode activity dialogs for dashboard redirects
      //console.log('process activity list', this.processActivityList)
      //console.log(this.processActivityList[0].activityprocess[0].activityDescription);
      // data.forEach(element =>{
      //   console.log('model elemnt',element);
      //   this.processActivityList.push(element)

      // })
      // // this.processActivityList = res;
      //console.log('processlist', this.processActivityList);
      this.getActivitiesOnCandidate(
        this.applicationIds[this.selectedAssignmentIndex].applicationId,
        this.selectedCandidateId,
        'footer',
      );
    });
    // this.associateService.getActivities().subscribe(res => {
    //   console.log(res);
    //   this.processActivityList = res;
    // })
  }
  editActivity(editactivity: any, activityMode) {
    this.activityMode = activityMode;
    this.coupledEditCheckCorrespondenceDataObj1 = undefined;
    this.coupledEditCheckHrPanelInterviewObj1 = undefined;
    this.coupledEditCheckInterviewDataObj1 = undefined;
    this.coupledEditCheckStatusChangeDataObj1 = undefined;
    this.coupledEditCheckSuitabilityDataObj1 = undefined;

    this.editcheckSuitabilityDataObj = undefined;
    this.editcheckCorrespondenceDataObj = undefined;
    this.editcheckInterviewDataObj = undefined;
    this.editcheckStatusChangeDataObj = undefined;
    this.editcheckHrPanelInterviewObj = undefined;

    this.coupledEditCheckCorrespondenceDataObj2 = undefined;
    this.coupledEditCheckHrPanelInterviewObj2 = undefined;
    this.coupledEditCheckInterviewDataObj2 = undefined;
    this.coupledEditCheckStatusChangeDataObj2 = undefined;
    this.coupledEditCheckSuitabilityDataObj2 = undefined;

    this.coupledOnStatusChangeScheduleEdit = false;
    this.coupledOnSuitabilityEdit = false;
    this.coupledOnCorrespondenceEdit = false;
    this.coupledOnInterviewScheduleEdit = false;
    this.coupledhrpanelInterviewEdit = false;

    this.onSuitabilityEdit = false;
    this.onCorrespondenceEdit = false;
    this.onInterviewScheduleEdit = false;
    this.onStatusChangeScheduleEdit = false;
    this.onHrPanelInterviewEdit = false;

    const tempIdObj: DataIds = {
      applicationId: Number(this.applicationIds[this.selectedAssignmentIndex].applicationId),
      processID: editactivity.processId,
      activityID: editactivity.activityId,
    };
    this.activityService.setDataIds(tempIdObj);
    let isapplicantData: any;
    this.activityService.isApplicantsActivityAvailable().subscribe((data: isApplicantsActivityAvailable) => {
      console.log(data);

      this.editactivityflag = !this.editactivityflag;
      console.log('this selected activity', editactivity);
      console.log(this.editactivityflag);
      const coupledActivity = data.coupledctivityTypeIsExists;
      console.log(coupledActivity);

      const activitytype = editactivity.activityType.toLowerCase();
      console.log('acttity vtype', activitytype);
      console.log(isapplicantData);
      console.log(data.coupledctivityTypeIsExists);

      // if(true)
      if (data.coupledctivityTypeIsExists) {
        console.log('inside if couple');
        this.ifCoupled = true;

        this.editCoupleActivity(activitytype, data.coupledctivityType.toLowerCase(), editactivity, data);
        // this.editCoupleActivity(activitytype,'simple activity',editactivity,data)

        console.log();
      } else {
        this.ifCoupled = false;
        if (activitytype) {
          switch (activitytype) {
            case 'simple activity': {
              console.log('in -----', activitytype);
              const editcheckSuitabilityDataObj: CheckSuitabilityDataObj = {
                candidateName: this.candidateBasicDetails.candidateName,
                processId: editactivity.processId,
                applicationId: Number(this.applicationIds[this.selectedAssignmentIndex].applicationId),
                activityId: editactivity.activityId,
                isVisible: true,
                activityName: editactivity.activityDescription,
                statusId: editactivity.statusId,
                createdOn: editactivity.createdOn,
                createdBy: editactivity.createdBy,
              };
              this.editcheckSuitabilityDataObj = editcheckSuitabilityDataObj;
              break;
            }
            case 'simple correspondence': {
              console.log('in -----', activitytype);
              const editcheckCorrespondenceDataObj: CorrespondenceDataObj = {
                candidateName: this.candidateBasicDetails.candidateName,
                processId: editactivity.processId,
                applicationId: Number(this.applicationIds[this.selectedAssignmentIndex].applicationId),
                activityId: editactivity.activityId,
                isVisible: true,
                activityName: editactivity.activityDescription,
                statusId: editactivity.statusId,
                createdOn: editactivity.createdOn,
                createdBy: editactivity.createdBy,
              };
              this.editcheckCorrespondenceDataObj = editcheckCorrespondenceDataObj;
              break;
            }
            case 'interview': {
              console.log('in -----', activitytype);
              const editcheckInterviewDataObj: CheckInterviewSchDataObj = {
                candidateName: this.candidateBasicDetails.candidateName,
                processId: editactivity.processId,
                applicationId: Number(this.applicationIds[this.selectedAssignmentIndex].applicationId),
                activityId: editactivity.activityId,
                isVisisble: true,
                activityName: editactivity.activityDescription,
                statusId: editactivity.statusId,
                createdOn: editactivity.createdOn,
                createdBy: editactivity.createdBy,
              };
              this.editcheckInterviewDataObj = editcheckInterviewDataObj;
              break;
            }
            case 'confirmation': {
              console.log('in -----', activitytype);
              let ishractivity = true;
              if (
                editactivity.activityDescription.toLowerCase().includes('panel') ||
                editactivity.activityDescription.toLowerCase().includes('ai bot')
              ) {
                ishractivity = false;
              }
              const editcheckHrPanelInterviewObj: HrPanelInterviewObj = {
                candidateName: this.candidateBasicDetails.candidateName,
                processId: editactivity.processId,
                applicationId: Number(this.applicationIds[this.selectedAssignmentIndex].applicationId),
                activityId: editactivity.activityId,
                isVisible: true,
                activityName: editactivity.activityDescription,
                statusId: editactivity.statusId,
                isHrActivity: ishractivity,
                createdOn: editactivity.createdOn,
                createdBy: editactivity.createdBy,
              };
              this.editcheckHrPanelInterviewObj = editcheckHrPanelInterviewObj;
              break;
            }
            case 'status change': {
              console.log('in -----', activitytype);
              const editcheckStatusChangeDataObj: CheckstatusChangeObj = {
                candidateName: this.candidateBasicDetails.candidateName,
                processId: editactivity.processId,
                applicationId: Number(this.applicationIds[this.selectedAssignmentIndex].applicationId),
                activityId: editactivity.activityId,
                isVisisble: true,
                activityName: editactivity.activityDescription,
                statusId: editactivity.statusId,
                createdOn: editactivity.createdOn,
                createdBy: editactivity.createdBy,
              };
              this.editcheckStatusChangeDataObj = editcheckStatusChangeDataObj;
              // this.setNoOfTimesActs(editactivity);
              this.noOfTimesActsExcted = undefined;
              break;
            }
          }
        }
      }
    });
  }
  editCoupleActivity(activitytype, coupledactivitytype, editactivity, data) {
    // data.coupledctivityType='simple correspondence';
    if (activitytype) {
      switch (activitytype) {
        case 'simple activity': {
          console.log('in -----', activitytype);
          console.log(editactivity.activityDescription);

          const couplededitcheckSuitabilityDataObj: CheckSuitabilityDataObj = {
            candidateName: this.candidateBasicDetails.candidateName,
            processId: editactivity.processId,
            applicationId: Number(this.applicationIds[this.selectedAssignmentIndex].applicationId),
            activityId: editactivity.activityId,
            isVisible: true,
            activityName: editactivity.activityDescription,
            statusId: editactivity.statusId,
            createdOn: editactivity.createdOn,
            createdBy: editactivity.createdBy,
          };

          this.coupledEditCheckSuitabilityDataObj1 = couplededitcheckSuitabilityDataObj;
          this.onSuitabilityEdit = true;

          switch (coupledactivitytype) {
            case 'simple activity': {
              console.log('in -----', activitytype);
              console.log(editactivity.activityDescription);

              const couplededitcheckSuitabilityDataObj4: CheckSuitabilityDataObj = {
                candidateName: this.candidateBasicDetails.candidateName,
                processId: editactivity.processId,
                applicationId: Number(this.applicationIds[this.selectedAssignmentIndex].applicationId),
                activityId: data.coupledActivityId,
                isVisible: true,
                activityName: editactivity.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity.statusId,
                createdOn: editactivity.createdOn,
                createdBy: editactivity.createdBy,
              };
              this.coupledEditCheckSuitabilityDataObj2 = couplededitcheckSuitabilityDataObj4;
              this.coupledOnSuitabilityEdit = true;
              console.log(this.coupledEditCheckSuitabilityDataObj2);

              break;
            }
            case 'simple correspondence': {
              console.log('in -----', activitytype);
              const couplededitcheckCorrespondenceDataObj2: CorrespondenceDataObj = {
                candidateName: this.candidateBasicDetails.candidateName,
                processId: editactivity.processId,
                applicationId: Number(this.applicationIds[this.selectedAssignmentIndex].applicationId),
                // activityId: editactivity.activityId,
                activityId: data.coupledActivityId,

                isVisible: true,
                // activityName: editactivity.activityDescription,
                activityName: data.coupleActivityDescription,
                statusId: editactivity.statusId,
                createdOn: editactivity.createdOn,
                createdBy: editactivity.createdBy,
              };
              this.coupledEditCheckCorrespondenceDataObj2 = couplededitcheckCorrespondenceDataObj2;
              this.coupledOnCorrespondenceEdit = true;
              break;
            }
            case 'interview': {
              console.log('in -----', activitytype);
              const couplededitcheckInterviewDataObj2: CheckInterviewSchDataObj = {
                candidateName: this.candidateBasicDetails.candidateName,
                processId: editactivity.processId,
                applicationId: Number(this.applicationIds[this.selectedAssignmentIndex].applicationId),
                // activityId: editactivity.activityId,
                activityId: data.coupledActivityId,
                isVisisble: true,
                activityName: editactivity.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity.statusId,
                createdOn: editactivity.createdOn,
                createdBy: editactivity.createdBy,
              };
              this.coupledEditCheckInterviewDataObj2 = couplededitcheckInterviewDataObj2;
              this.coupledOnInterviewScheduleEdit = true;
              break;
            }
            case 'confirmation': {
              console.log('in -----', activitytype);
              let ishractivity = true;
              if (editactivity.activityDescription.toLowerCase().includes('panel')) {
                ishractivity = false;
              }
              const couplededitcheckHrPanelInterviewObj2: HrPanelInterviewObj = {
                candidateName: this.candidateBasicDetails.candidateName,
                activityId: data.coupledActivityId,
                isVisible: true,
                activityName: editactivity.activityDescription,
                processId: editactivity.processId,
                applicationId: Number(this.applicationIds[this.selectedAssignmentIndex].applicationId),
                // activityId: editactivity.activityId,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity.statusId,
                isHrActivity: ishractivity,
                createdOn: editactivity.createdOn,
                createdBy: editactivity.createdBy,
              };
              this.coupledEditCheckHrPanelInterviewObj2 = couplededitcheckHrPanelInterviewObj2;
              this.coupledhrpanelInterviewEdit = true;
              break;
            }
            case 'status change': {
              console.log('in -----', activitytype);
              const couplededitcheckStatusChangeDataObj2: CheckstatusChangeObj = {
                candidateName: this.candidateBasicDetails.candidateName,
                processId: editactivity.processId,
                applicationId: Number(this.applicationIds[this.selectedAssignmentIndex].applicationId),
                // activityId: editactivity.activityId,
                activityId: data.coupledActivityId,
                statusId: editactivity.statusId,
                createdOn: editactivity.createdOn,
                isVisisble: true,
                activityName: editactivity.activityDescription,
                // activityName:data.coupleActivityDescription,
                createdBy: editactivity.createdBy,
              };
              this.coupledEditCheckStatusChangeDataObj2 = couplededitcheckStatusChangeDataObj2;
              this.coupledOnStatusChangeScheduleEdit = true;
              break;
            }
          }

          break;
        }
        case 'simple correspondence': {
          console.log('in -----', activitytype);
          const couplededitcheckCorrespondenceDataObj: CorrespondenceDataObj = {
            candidateName: this.candidateBasicDetails.candidateName,
            processId: editactivity.processId,
            applicationId: Number(this.applicationIds[this.selectedAssignmentIndex].applicationId),
            activityId: editactivity.activityId,
            isVisible: true,
            activityName: editactivity.activityDescription,
            statusId: editactivity.statusId,
            createdOn: editactivity.createdOn,
            createdBy: editactivity.createdBy,
          };
          this.coupledEditCheckCorrespondenceDataObj1 = couplededitcheckCorrespondenceDataObj;
          this.onCorrespondenceEdit = true;

          switch (coupledactivitytype) {
            case 'simple activity': {
              console.log('in -----', activitytype);
              console.log(editactivity.activityDescription);

              const couplededitcheckSuitabilityDataObj5: CheckSuitabilityDataObj = {
                candidateName: this.candidateBasicDetails.candidateName,
                processId: editactivity.processId,
                applicationId: Number(this.applicationIds[this.selectedAssignmentIndex].applicationId),
                activityId: data.coupledActivityId,
                isVisible: true,
                activityName: editactivity.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity.statusId,
                createdOn: editactivity.createdOn,
                createdBy: editactivity.createdBy,
              };
              this.coupledEditCheckSuitabilityDataObj2 = couplededitcheckSuitabilityDataObj5;
              this.coupledOnSuitabilityEdit = true;
              console.log(this.coupledEditCheckSuitabilityDataObj2);

              break;
            }
            case 'simple correspondence': {
              console.log('in -----', activitytype);
              const couplededitcheckCorrespondenceDataObj3: CorrespondenceDataObj = {
                candidateName: this.candidateBasicDetails.candidateName,
                processId: editactivity.processId,
                applicationId: Number(this.applicationIds[this.selectedAssignmentIndex].applicationId),
                // activityId: editactivity.activityId,
                activityId: data.coupledActivityId,
                isVisible: true,
                activityName: editactivity.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity.statusId,
                createdOn: editactivity.createdOn,
                createdBy: editactivity.createdBy,
              };
              this.coupledEditCheckCorrespondenceDataObj2 = couplededitcheckCorrespondenceDataObj3;
              this.coupledOnCorrespondenceEdit = true;
              break;
            }
            case 'interview': {
              console.log('in -----', activitytype);
              const couplededitcheckInterviewDataObj3: CheckInterviewSchDataObj = {
                candidateName: this.candidateBasicDetails.candidateName,
                processId: editactivity.processId,
                applicationId: Number(this.applicationIds[this.selectedAssignmentIndex].applicationId),
                // activityId: editactivity.activityId,
                activityId: data.coupledActivityId,
                isVisisble: true,
                activityName: editactivity.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity.statusId,
                createdOn: editactivity.createdOn,
                createdBy: editactivity.createdBy,
              };
              this.coupledEditCheckInterviewDataObj2 = couplededitcheckInterviewDataObj3;
              this.coupledOnInterviewScheduleEdit = true;
              break;
            }
            case 'confirmation': {
              console.log('in -----', activitytype);
              let ishractivity = true;
              if (editactivity.activityDescription.toLowerCase().includes('panel')) {
                ishractivity = false;
              }
              const couplededitcheckHrPanelInterviewObj2: HrPanelInterviewObj = {
                candidateName: this.candidateBasicDetails.candidateName,
                processId: editactivity.processId,
                applicationId: Number(this.applicationIds[this.selectedAssignmentIndex].applicationId),
                // activityId: editactivity.activityId,
                activityName: editactivity.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity.statusId,
                activityId: data.coupledActivityId,
                isVisible: true,
                isHrActivity: ishractivity,
                createdOn: editactivity.createdOn,
                createdBy: editactivity.createdBy,
              };
              this.coupledEditCheckHrPanelInterviewObj2 = couplededitcheckHrPanelInterviewObj2;
              this.coupledhrpanelInterviewEdit = true;
              break;
            }
            case 'status change': {
              console.log('in -----', activitytype);
              const couplededitcheckStatusChangeDataObj2: CheckstatusChangeObj = {
                candidateName: this.candidateBasicDetails.candidateName,
                processId: editactivity.processId,
                applicationId: Number(this.applicationIds[this.selectedAssignmentIndex].applicationId),
                isVisisble: true,
                activityName: editactivity.activityDescription,
                // activityId: editactivity.activityId,
                activityId: data.coupledActivityId,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity.statusId,
                createdOn: editactivity.createdOn,
                createdBy: editactivity.createdBy,
              };
              this.coupledEditCheckStatusChangeDataObj2 = couplededitcheckStatusChangeDataObj2;
              this.coupledOnStatusChangeScheduleEdit = true;
              break;
            }
          }

          break;
        }
        case 'interview': {
          console.log('in -----', activitytype);
          const couplededitcheckInterviewDataObj: CheckInterviewSchDataObj = {
            candidateName: this.candidateBasicDetails.candidateName,
            processId: editactivity.processId,
            applicationId: Number(this.applicationIds[this.selectedAssignmentIndex].applicationId),
            activityId: editactivity.activityId,
            isVisisble: true,
            activityName: editactivity.activityDescription,
            statusId: editactivity.statusId,
            createdOn: editactivity.createdOn,
            createdBy: editactivity.createdBy,
          };
          this.coupledEditCheckInterviewDataObj1 = couplededitcheckInterviewDataObj;
          this.onInterviewScheduleEdit = true;

          switch (coupledactivitytype) {
            case 'simple activity': {
              console.log('in -----', activitytype);
              console.log(editactivity.activityDescription);

              const couplededitcheckSuitabilityDataObj7: CheckSuitabilityDataObj = {
                candidateName: this.candidateBasicDetails.candidateName,
                processId: editactivity.processId,
                applicationId: Number(this.applicationIds[this.selectedAssignmentIndex].applicationId),
                activityId: data.coupledActivityId,
                isVisible: true,
                activityName: editactivity.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity.statusId,
                createdOn: editactivity.createdOn,
                createdBy: editactivity.createdBy,
              };
              this.coupledEditCheckSuitabilityDataObj2 = couplededitcheckSuitabilityDataObj7;
              this.coupledOnSuitabilityEdit = true;
              console.log(this.coupledEditCheckSuitabilityDataObj2);

              break;
            }
            case 'simple correspondence': {
              console.log('in -----', activitytype);
              const couplededitcheckCorrespondenceDataObj4: CorrespondenceDataObj = {
                candidateName: this.candidateBasicDetails.candidateName,
                processId: editactivity.processId,
                applicationId: Number(this.applicationIds[this.selectedAssignmentIndex].applicationId),
                // activityId: editactivity.activityId,
                activityId: data.coupledActivityId,
                isVisible: true,
                activityName: editactivity.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity.statusId,
                createdOn: editactivity.createdOn,
                createdBy: editactivity.createdBy,
              };
              this.coupledEditCheckCorrespondenceDataObj2 = couplededitcheckCorrespondenceDataObj4;
              this.coupledOnCorrespondenceEdit = true;
              break;
            }
            case 'interview': {
              console.log('in -----', activitytype);
              const couplededitcheckInterviewDataObj4: CheckInterviewSchDataObj = {
                candidateName: this.candidateBasicDetails.candidateName,
                processId: editactivity.processId,
                applicationId: Number(this.applicationIds[this.selectedAssignmentIndex].applicationId),
                // activityId: editactivity.activityId,
                activityId: data.coupledActivityId,
                isVisisble: true,
                activityName: editactivity.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity.statusId,
                createdOn: editactivity.createdOn,
                createdBy: editactivity.createdBy,
              };
              this.coupledEditCheckInterviewDataObj2 = couplededitcheckInterviewDataObj4;
              this.coupledOnInterviewScheduleEdit = true;
              break;
            }
            case 'confirmation': {
              console.log('in -----', activitytype);
              let ishractivity = true;
              if (editactivity.activityDescription.toLowerCase().includes('panel')) {
                ishractivity = false;
              }
              const couplededitcheckHrPanelInterviewObj2: HrPanelInterviewObj = {
                processId: editactivity.processId,
                candidateName: this.candidateBasicDetails.candidateName,
                applicationId: Number(this.applicationIds[this.selectedAssignmentIndex].applicationId),
                // activityId: editactivity.activityId,
                activityId: data.coupledActivityId,
                isVisible: true,
                activityName: editactivity.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity.statusId,
                isHrActivity: ishractivity,
                createdOn: editactivity.createdOn,
                createdBy: editactivity.createdBy,
              };
              this.coupledEditCheckHrPanelInterviewObj2 = couplededitcheckHrPanelInterviewObj2;
              this.coupledhrpanelInterviewEdit = true;
              break;
            }
            case 'status change': {
              console.log('in -----', activitytype);
              const couplededitcheckStatusChangeDataObj2: CheckstatusChangeObj = {
                candidateName: this.candidateBasicDetails.candidateName,
                processId: editactivity.processId,
                applicationId: Number(this.applicationIds[this.selectedAssignmentIndex].applicationId),
                // activityId: editactivity.activityId,
                activityId: data.coupledActivityId,
                isVisisble: true,
                activityName: editactivity.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity.statusId,
                createdOn: editactivity.createdOn,
                createdBy: editactivity.createdBy,
              };
              this.coupledEditCheckStatusChangeDataObj2 = couplededitcheckStatusChangeDataObj2;
              this.coupledOnStatusChangeScheduleEdit = true;
              break;
            }
          }

          break;
        }
        case 'confirmation': {
          console.log('in -----', activitytype);
          let ishractivity = true;
          if (editactivity.activityDescription.toLowerCase().includes('panel')) {
            ishractivity = false;
          }
          const couplededitcheckHrPanelInterviewObj: HrPanelInterviewObj = {
            candidateName: this.candidateBasicDetails.candidateName,
            processId: editactivity.processId,
            applicationId: Number(this.applicationIds[this.selectedAssignmentIndex].applicationId),
            activityId: editactivity.activityId,
            isVisible: true,
            activityName: editactivity.activityDescription,
            statusId: editactivity.statusId,
            isHrActivity: ishractivity,
            createdOn: editactivity.createdOn,
            createdBy: editactivity.createdBy,
          };
          this.coupledEditCheckHrPanelInterviewObj1 = couplededitcheckHrPanelInterviewObj;
          this.onHrPanelInterviewEdit = true;

          switch (coupledactivitytype) {
            case 'simple activity': {
              console.log('in -----', activitytype);
              console.log(editactivity.activityDescription);

              const couplededitcheckSuitabilityDataObj8: CheckSuitabilityDataObj = {
                candidateName: this.candidateBasicDetails.candidateName,
                processId: editactivity.processId,
                applicationId: Number(this.applicationIds[this.selectedAssignmentIndex].applicationId),
                // activityId: data.coupledActivityId,
                activityId: data.coupledActivityId,
                isVisible: true,
                activityName: editactivity.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity.statusId,
                createdOn: editactivity.createdOn,
                createdBy: editactivity.createdBy,
              };
              this.coupledEditCheckSuitabilityDataObj2 = couplededitcheckSuitabilityDataObj8;
              this.coupledOnSuitabilityEdit = true;
              console.log(this.coupledEditCheckSuitabilityDataObj2);

              break;
            }
            case 'simple correspondence': {
              console.log('in -----', activitytype);
              const couplededitcheckCorrespondenceDataObj2: CorrespondenceDataObj = {
                candidateName: this.candidateBasicDetails.candidateName,
                processId: editactivity.processId,
                applicationId: Number(this.applicationIds[this.selectedAssignmentIndex].applicationId),
                // activityId: editactivity.activityId,
                activityId: data.coupledActivityId,
                isVisible: true,
                activityName: editactivity.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity.statusId,
                createdOn: editactivity.createdOn,
                createdBy: editactivity.createdBy,
              };
              this.coupledEditCheckCorrespondenceDataObj2 = couplededitcheckCorrespondenceDataObj2;
              this.coupledOnCorrespondenceEdit = true;
              break;
            }
            case 'interview': {
              console.log('in -----', activitytype);
              const couplededitcheckInterviewDataObj5: CheckInterviewSchDataObj = {
                candidateName: this.candidateBasicDetails.candidateName,
                processId: editactivity.processId,
                applicationId: Number(this.applicationIds[this.selectedAssignmentIndex].applicationId),
                // activityId: editactivity.activityId,
                activityId: data.coupledActivityId,
                isVisisble: true,
                activityName: editactivity.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity.statusId,
                createdOn: editactivity.createdOn,
                createdBy: editactivity.createdBy,
              };
              this.coupledEditCheckInterviewDataObj2 = couplededitcheckInterviewDataObj5;
              this.coupledOnInterviewScheduleEdit = true;
              break;
            }
            case 'confirmation': {
              console.log('in -----', activitytype);
              let ishractivity = true;
              if (editactivity.activityDescription.toLowerCase().includes('panel')) {
                ishractivity = false;
              }
              const couplededitcheckHrPanelInterviewObj2: HrPanelInterviewObj = {
                candidateName: this.candidateBasicDetails.candidateName,
                processId: editactivity.processId,
                applicationId: Number(this.applicationIds[this.selectedAssignmentIndex].applicationId),
                // activityId: editactivity.activityId,
                activityId: data.coupledActivityId,
                isVisible: true,
                activityName: editactivity.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity.statusId,
                isHrActivity: ishractivity,
                createdOn: editactivity.createdOn,
                createdBy: editactivity.createdBy,
              };
              this.coupledEditCheckHrPanelInterviewObj2 = couplededitcheckHrPanelInterviewObj2;
              this.coupledhrpanelInterviewEdit = true;
              break;
            }
            case 'status change': {
              console.log('in -----', activitytype);
              const couplededitcheckStatusChangeDataObj2: CheckstatusChangeObj = {
                candidateName: this.candidateBasicDetails.candidateName,
                processId: editactivity.processId,
                applicationId: Number(this.applicationIds[this.selectedAssignmentIndex].applicationId),
                // activityId: editactivity.activityId,
                activityId: data.coupledActivityId,
                isVisisble: true,
                activityName: editactivity.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity.statusId,
                createdOn: editactivity.createdOn,
                createdBy: editactivity.createdBy,
              };
              this.coupledEditCheckStatusChangeDataObj2 = couplededitcheckStatusChangeDataObj2;
              this.coupledOnStatusChangeScheduleEdit = true;
              break;
            }
          }

          break;
        }
        case 'status change': {
          console.log('in -----', activitytype);
          const couplededitcheckStatusChangeDataObj: CheckstatusChangeObj = {
            candidateName: this.candidateBasicDetails.candidateName,
            processId: editactivity.processId,
            applicationId: Number(this.applicationIds[this.selectedAssignmentIndex].applicationId),
            activityId: editactivity.activityId,

            isVisisble: true,
            activityName: editactivity.activityDescription,
            statusId: editactivity.statusId,
            createdOn: editactivity.createdOn,
            createdBy: editactivity.createdBy,
          };
          this.coupledEditCheckStatusChangeDataObj1 = couplededitcheckStatusChangeDataObj;
          this.onStatusChangeScheduleEdit = true;
          console.log(this.coupledEditCheckStatusChangeDataObj1);
          switch (coupledactivitytype) {
            case 'simple activity': {
              console.log('in -----', activitytype);
              console.log(editactivity.activityDescription);

              const couplededitcheckSuitabilityDataObj9: CheckSuitabilityDataObj = {
                candidateName: this.candidateBasicDetails.candidateName,
                processId: editactivity.processId,
                applicationId: Number(this.applicationIds[this.selectedAssignmentIndex].applicationId),
                activityId: data.coupledActivityId,
                isVisible: true,
                activityName: editactivity.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity.statusId,
                createdOn: editactivity.createdOn,
                createdBy: editactivity.createdBy,
              };
              this.coupledEditCheckSuitabilityDataObj2 = couplededitcheckSuitabilityDataObj9;
              this.coupledOnSuitabilityEdit = true;
              console.log(this.coupledEditCheckSuitabilityDataObj2);

              break;
            }
            case 'simple correspondence': {
              console.log('in -----', activitytype);
              const couplededitcheckCorrespondenceDataObj5: CorrespondenceDataObj = {
                candidateName: this.candidateBasicDetails.candidateName,
                processId: editactivity.processId,
                applicationId: Number(this.applicationIds[this.selectedAssignmentIndex].applicationId),
                // activityId: editactivity.activityId,
                activityId: data.coupledActivityId,
                isVisible: true,
                activityName: editactivity.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity.statusId,
                createdOn: editactivity.createdOn,
                createdBy: editactivity.createdBy,
              };
              this.coupledEditCheckCorrespondenceDataObj2 = couplededitcheckCorrespondenceDataObj5;
              this.coupledOnCorrespondenceEdit = true;
              break;
            }
            case 'interview': {
              console.log('in -----', activitytype);
              const couplededitcheckInterviewDataObj6: CheckInterviewSchDataObj = {
                candidateName: this.candidateBasicDetails.candidateName,
                processId: editactivity.processId,
                applicationId: Number(this.applicationIds[this.selectedAssignmentIndex].applicationId),
                // activityId: editactivity.activityId,
                activityId: data.coupledActivityId,
                isVisisble: true,
                activityName: editactivity.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity.statusId,
                createdOn: editactivity.createdOn,
                createdBy: editactivity.createdBy,
              };
              this.coupledEditCheckInterviewDataObj2 = couplededitcheckInterviewDataObj6;
              this.coupledOnInterviewScheduleEdit = true;
              break;
            }
            case 'confirmation': {
              console.log('in -----', activitytype);
              let ishractivity = true;
              if (editactivity.activityDescription.toLowerCase().includes('panel')) {
                ishractivity = false;
              }
              const couplededitcheckHrPanelInterviewObj2: HrPanelInterviewObj = {
                candidateName: this.candidateBasicDetails.candidateName,
                processId: editactivity.processId,
                applicationId: Number(this.applicationIds[this.selectedAssignmentIndex].applicationId),
                activityId: editactivity.activityId,
                isVisible: true,
                activityName: editactivity.activityDescription,
                // activityName:data.coupleActivityDescription,
                isHrActivity: ishractivity,
                createdOn: editactivity.createdOn,
                statusId: editactivity.statusId,
                createdBy: editactivity.createdBy,
              };
              this.coupledEditCheckHrPanelInterviewObj2 = couplededitcheckHrPanelInterviewObj2;
              this.coupledhrpanelInterviewEdit = true;
              break;
            }
            case 'status change': {
              console.log('in -----', activitytype);
              const couplededitcheckStatusChangeDataObj2: CheckstatusChangeObj = {
                candidateName: this.candidateBasicDetails.candidateName,
                processId: editactivity.processId,
                applicationId: Number(this.applicationIds[this.selectedAssignmentIndex].applicationId),
                // activityId: editactivity.activityId,
                activityId: data.coupledActivityId,
                isVisisble: true,
                // activityName: editactivity.activityDescription,
                activityName: data.coupleActivityDescription,
                statusId: editactivity.statusId,
                createdOn: editactivity.createdOn,
                createdBy: editactivity.createdBy,
              };
              this.coupledEditCheckStatusChangeDataObj2 = couplededitcheckStatusChangeDataObj2;
              console.log(this.coupledEditCheckStatusChangeDataObj2);

              this.coupledOnStatusChangeScheduleEdit = true;
              console.log(this.coupledOnStatusChangeScheduleEdit);
              break;
            }
          }

          break;
        }
      }
    }
  }
  resetFlag = function () {
    console.log('Flag Reset Called');
    this.editactivityflag = false;
    this.ifCoupled = false;
    this.clearActivityObj();
  };
  clearActivityObj() {
    this.ifCoupled = false;
    this.checkSuitabilityDataObj = undefined;
    this.coupledCheckSuitabilityDataObj = undefined;
    this.coupledCheckStatusChangeObj = undefined;
    this.onSuitability = false;
    this.coupledOnSuitability = false;
    this.onCorrespondence = false;
    this.coupledOnCorrespondence = false;
    this.correspondenceDataObj = undefined;
    this.couplledCorrespondenceDataObj = undefined;
    this.checkInterviewSchDataObj = undefined;
    this.coupledCheckInterviewSchDataObj = undefined;
    this.checkStatusChangeObj = undefined;
    this.onInterview = false;
    this.onInterviewSchedule = false;
    this.coupledOnInterviewSchedule = false;
    this.onStatusChangeSchedule = false;
    this.coupledOnStatusChangeSchedule = false;
    this.checkHrPanelInterviewObj = undefined;
    this.onHrPanelInterview = false;
    this.coupledcheckHrPanelInterviewObj = undefined;
    this.coupled2checkHrPanelInterviewObj = undefined;
    this.coupled2CheckInterviewSchDataObj = undefined;
    this.coupled2CheckStatusChangeObj = undefined;
    this.coupled2CheckSuitabilityDataObj = undefined;
    this.coupled2OnCorrespondence = false;
    this.coupled2hrpanelInterview = false;
    this.coupled2OnInterviewSchedule = false;
    this.coupled2OnSuitability = false;
    this.coupled2OnStatusChangeSchedule = false;
    this.coupledcheckHrPanelInterviewObj = undefined;
    this.checkSuitabilityDataObj = undefined;
    this.coupledCheckSuitabilityDataObj = undefined;
    this.correspondenceDataObj = undefined;
    this.couplledCorrespondenceDataObj = undefined;
    this.checkInterviewSchDataObj = undefined;
    this.coupledCheckInterviewSchDataObj = undefined;
    this.checkStatusChangeObj = undefined;
    this.coupledCheckStatusChangeObj = undefined;
    this.onSuitability = false;
    this.coupledOnSuitability = false;
    this.onCorrespondence = false;
    this.coupledOnCorrespondence = false;
    this.onInterview = false;
    this.onInterviewSchedule = false;
    this.coupledOnStatusChangeSchedule = false;
    this.checkHrPanelInterviewObj = undefined;
    this.onHrPanelInterview = false;
    this.coupledOnInterviewSchedule = false;
    this.onStatusChangeSchedule = false;
    this.coupledcheckHrPanelInterviewObj = undefined;
  }
  getCandidateListByIds(applicationIds) {
    this.associateService.getCandidateListByIds(applicationIds).subscribe(
      (res) => {
        this.candidatesList = res;
        console.log(this.candidatesList);
        if (this.candidatesList.length > 0) {
          for (let i = 0; i < this.candidatesList.length; i++) {
            if (this.candidatesList[i].candidateId === this.selectedCandidateId) {
              this.selectedCandidate.push(this.candidatesList[i]);
              this.selectedCandidate[0].applicationId = this.applicationIds[this.selectedAssignmentIndex].applicationId;
              break;
            }
          }
          this.candidateEmails = [];
          this.selectedCandidate.forEach((value) => {
            console.log('foreach of selectedcandidate', value);
            this.candidateEmails.push(String(value['emailId']));
          });
        }
        console.log(this.selectedCandidate);
        this.dataLoadStatus.candidateList = true;
        // If selectedCandidate already loaded, open menu now
        this.tryAutoTriggerMenu();
      },
      (err) => {
        console.log(err);
      },
    );
  }
  setActivityState() {
    this.reloadTree();
    console.log('new activyty selected,setting activity state true');
    this.activityState = true;
  }
  // selectRequisition(id){
  //   console.log(id);
  //   this.selectedRequisitionId = id.requisitionName;
  //   this.associateService.getJobDescription(id.requisitionId).subscribe((data) => {
  //     this.popupData=data;
  //     console.log(this.popupData);
  //     this.openDialog();
  //   });
  // }
  selectRequisition(reqId) {
    console.log(reqId);
    this.selectedRequisitionId = reqId.requisitionName;
    this.associateService.getJobDescription(reqId.requisitionId).subscribe((data) => {
      this.popupData = data;
      this._personaService.getRequsitionDetails(reqId.requisitionId).subscribe((res) => {
        console.log(res);
        this.popupData['unit'] = res['unit'];
        // this.popupData['recruiterId'] = res['recruiterId'];
        this.popupData['title'] = res['title'];
        this._personaService.getSupportTeamList(reqId.requisitionId).subscribe((supres) => {
          // if(supres.length>0){
          //   this.popupData['supportTeam'] = supres;
          // }
          if (res['recruiterId']) {
            supres.push(res['recruiterId'].toString());
          }
          console.log(supres);
          this.activityService.getEmployeeDetails(supres).subscribe((employeeDetails) => {
            console.log(employeeDetails);

            if (supres.length > 0) {
              const supportteamNames = [];
              for (let index = 0; index < employeeDetails.empDetails.length; index++) {
                if (employeeDetails.empDetails[index].empId === res['recruiterId'].toString()) {
                  this.popupData['recruiterId'] = employeeDetails.empDetails[index].mailId.slice(0, -12);
                } else {
                  supportteamNames.push(employeeDetails.empDetails[index].mailId.slice(0, -12));
                  this.popupData['supportTeam'] = supportteamNames;
                }
              }
            }
          });
          // this.activityService.getHrDetail(res['recruiterId']).subscribe(recName=>{
          //   console.log(recName);
          //   this.popupData['recruiterId'] = recName.mailId;
          //   if(supres.length>0){
          //     let supportTeamNames = [];
          //     supres.forEach(element => {
          //       this.activityService.getHrDetail(element).subscribe(supName=>{
          //         supportTeamNames.push(supName.mailId);
          //         this.popupData['supportTeam'] = supportTeamNames.toString();
          //       });
          //     });
          //   }
          // })
          this.openDialog();
        });
        //  this.openDialog();
      });
    });
  }
  reloadTree() {
    this.enabled = false;
    // now notify angular to check for updates
    this.changeDetector.detectChanges();
    // change detection should remove the component now
    // then we can enable it again to create a new instance
    this.enabled = true;
  }

  tryAutoTriggerMenu() {
    // Check all prerequisites are met before attempting to trigger
    if (
      this.pendingAutoTrigger &&
      this.dataLoadStatus.processActivities &&
      this.dataLoadStatus.candidateList &&
      this.dataLoadStatus.applicationIds &&
      this.selectedCandidate?.length > 0 &&
      this.processActivityList?.length > 0
    ) {
      // Use setTimeout to ensure view is fully initialized
      setTimeout(() => {
        this.setActivityState();
      }, 1000);
    }
  }
  callrefreshcandiates(val) {
    console.log('details----' + val);
    // this.refreshpostingcandiates.emit(true);
    // this.ngOnInit()
    this.clearActivityObj();
    // this.ngOnInit()
    this.getActivitiesOnCandidate(
      this.applicationIds[this.selectedAssignmentIndex].applicationId,
      this.selectedCandidateId,
      'activityUpdate',
    );
  }
  openFile(data) {
    if (data && data.objectId && data.objectType && data.attachmentId) {
      this._searchCandServ.getFileId(data).subscribe((data) => {
        this.fileId = data;
        this._searchCandServ.getResume(this.fileId.id).subscribe(async (data) => {
          if (data) {
            this.resData = data;
            const fileType = this.resData.fileType
              ? (this.resData.fileType.charAt(0) === '.' ? this.resData.fileType : '.' + this.resData.fileType)
              : '';
            const fileName =
              this.selectedCandidateId + '_' + this.candidateBasicDetails.candidateName.replaceAll(' ', '') + fileType;

            try {
              await this.fileDownloadService.downloadFileFromResponse(this.resData, fileName);
            } catch (_error) {
              this.activityService.openSnackBar({ msg: 'Resume download failed', isSuccess: false }, 'danger-snack');
            }
          }
        });
      });
    }
  }

  getAppId(appId) {
    console.log('Application Id' + appId);

    const index = this.applicationIds.findIndex((obj) => obj.applicationId === appId);

    this.selectedAssignmentTab.setValue(index);
    this.onAssignmentChange(index);
    console.log(index);
  }

  getActsCount() {
    const schedulingActs = this.groupedActivities['40'];
    this.notAvailableCountScheduling = schedulingActs?.filter((elem) => elem?.activityId === 400405)?.length || 0;
    this.notReachableCountScheduling = schedulingActs?.filter((elem) => elem?.activityId === 400406)?.length || 0;

    //get the latest date  from schedulingActs from both 400405 and 400406 and store in notAvailableDateScheduling and notReachableCountScheduling repectively
    //get the latest date from schedulingActs from both 400405 and 400406 and store in notAvailableDateScheduling and notReachableDateScheduling respectively
    const notAvailableSchedulingDates =
      schedulingActs?.filter((elem) => elem?.activityId === 400405)?.map((elem) => new Date(elem?.unavailableDate)) ||
      [];
    const notReachableSchedulingDates =
      schedulingActs?.filter((elem) => elem?.activityId === 400406)?.map((elem) => new Date(elem?.unavailableDate)) ||
      [];

    // Find the latest date directly
    this.notAvailableDateScheduling =
      notAvailableSchedulingDates.length > 0
        ? notAvailableSchedulingDates.reduce((latest, current) => (current > latest ? current : latest))
        : null;
    this.notReachableDateScheduling =
      notReachableSchedulingDates.length > 0
        ? notReachableSchedulingDates.reduce((latest, current) => (current > latest ? current : latest))
        : null;

    const interviewActs = this.groupedActivities['50'];
    this.notAvailableCountInterview = interviewActs?.filter((elem) => elem?.activityId === 400405)?.length || 0;
    this.notReachableCountInterview = interviewActs?.filter((elem) => elem?.activityId === 400406)?.length || 0;

    //get the latest date from interviewActs from both 400406 and 400405 and store in notAvailableDateInterview and notReachableDateInterview respectively
    const notAvailableInterviewDates =
      interviewActs?.filter((elem) => elem?.activityId === 400405)?.map((elem) => new Date(elem?.unavailableDate)) ||
      [];
    const notReachableInterviewDates =
      interviewActs?.filter((elem) => elem?.activityId === 400406)?.map((elem) => new Date(elem?.unavailableDate)) ||
      [];

    // Find the latest date directly
    this.notAvailableDateInterview =
      notAvailableInterviewDates.length > 0
        ? notAvailableInterviewDates.reduce((latest, current) => (current > latest ? current : latest))
        : null;
    this.notReachableDateInterview =
      notReachableInterviewDates.length > 0
        ? notReachableInterviewDates.reduce((latest, current) => (current > latest ? current : latest))
        : null;

    // this.noShowCount = interviewActs?.filter((elem) => elem?.activityId ===500302)?.length;
  }

  setNoOfTimesActs(obj) {
    if (obj.processId == 40 && obj.activityId == 400406) {
      this.noOfTimesActsExcted = this.notReachableCountScheduling;
      this.minDateAllowed = this.notReachableDateScheduling ? new Date(this.notReachableDateScheduling) : null;
    } else if (obj.processId == 40 && obj.activityId == 400405) {
      this.noOfTimesActsExcted = this.notAvailableCountScheduling;
      this.minDateAllowed = this.notAvailableDateScheduling ? new Date(this.notAvailableDateScheduling) : null;
    } else if (obj.processId == 50 && obj.activityId == 400406) {
      this.noOfTimesActsExcted = this.notReachableCountInterview;
      this.minDateAllowed = this.notReachableDateInterview ? new Date(this.notReachableDateInterview) : null;
    } else if (obj.processId == 50 && obj.activityId == 400405) {
      this.noOfTimesActsExcted = this.notAvailableCountInterview;
      this.minDateAllowed = this.notAvailableDateInterview ? new Date(this.notAvailableDateInterview) : null;
    }
    //make minDate to next day of the date
    if (this.minDateAllowed) {
      this.minDateAllowed.setDate(this.minDateAllowed.getDate() + 1);
    }
  }
  openShlDetails() {
    console.log(this.amcatId(), 'AMCT IN SHL');
    const amcatObj = {
      // CandidateId : this.selectedCandidateId,
      amcatId: this.amcatId(),
    };
    this.router.navigate(['scheduler/search/shl-results'], { state: { amcatObj: amcatObj } });
  }

  // Navigate back to recruiter action pending
  navigateBack(): void {
    const userTabLocation = localStorage.getItem('userTabLocation');
    if (userTabLocation) {
      const tabSelectionObj = JSON.parse(userTabLocation);
      const tabName = tabSelectionObj.recruiterTab || 'Action Pending';

      // Navigate to recruiter action pending component with the tab
      this.router.navigate(['/recruiter/inbox'], {
        queryParams: { tabName: tabName },
      });

      // Clear the stored location after navigation
      localStorage.removeItem('userTabLocation');
    } else {
      // Fallback to dashboard if no stored location
      this.router.navigate(['/recruiter/dashboard']);
    }
  }

  // Auto-scroll to specific activity section with loader
  scrollToElement(elementId: string): void {
    this.ngxLoader.start();
    setTimeout(() => {
      const element = document.getElementById(elementId);
      if (element) {
        requestAnimationFrame(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          // Wait for smooth scroll animation to complete before stopping loader
          setTimeout(() => {
            this.ngxLoader.stop();
          }, 800);
        });
      } else {
        this.ngxLoader.stop();
      }
    }, 1000);
  }
}
